export default () => {

  const form = document.getElementById('home-search-form');

  const input = document.getElementById('home-search-form-input');

  if (!input) {
    return;
  }

  const suggestions = document.getElementById('home-search-suggestions');

  const defaultValue = input.getAttribute('data-default-value');
  const defaultPlaceholder = input.getAttribute('data-placeholder');
  const CLASS_ACTIVE = 'active';
  const autocomplete = new google.maps.places.Autocomplete(input);
  autocomplete.setComponentRestrictions({'country': ['uk']});

  const redirectToResultsPage = (parameter, value) => {
    const url = `${form.action}?${parameter}=${value}`;
    location.assign(url);
  };

  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();

    if (place.geometry) {
      redirectToResultsPage('place_id', place.place_id);
    } else {
      redirectToResultsPage('value', place.name);
    }

  });

  if (suggestions) {
    const showSuggestions = () => {
      suggestions.classList.add(CLASS_ACTIVE);
    };

    const hideSuggestions = () => {
      suggestions.classList.remove(CLASS_ACTIVE);
    };

    input.addEventListener('focus', () => {
      input.placeholder = defaultPlaceholder;
      if (input.value.length === 0) {
        showSuggestions();
      }
    });

    input.addEventListener('blur', (e) => {
      if (e.relatedTarget && e.relatedTarget.classList.contains('pac-item')) return;
      setTimeout(() => {
        input.placeholder = defaultValue;
        hideSuggestions();
      }, 100);
    });

    input.addEventListener('input', () => {
      suggestions.classList.remove(CLASS_ACTIVE);
      if (input.value.length > 0) {
        hideSuggestions();
      } else {
        showSuggestions();
      }
    });
  }

  form.addEventListener('submit', e => {
    e.preventDefault();
    const value = input.value ? input.value : defaultValue;
    redirectToResultsPage('value', value);
  });
}
